import { JSX } from "react";
import DashboardTile from "@app/shared/qes-standards/DashboardTile";
import ProviderFootprintMap from "@app/overviews/market-expansion-dashboard/components/provider-footprint-map/ProviderFootprintMap";

const ProviderFootprintTile = (): JSX.Element => {
  return (
    <DashboardTile title={"Contract Entity Footprint"} widthClass="col-12" classNames="px-2">
      <ProviderFootprintMap />
    </DashboardTile>
  );
};

export default ProviderFootprintTile;